module.exports = __webpack_public_path__ + "static/media/unitinfo2.0e0a3c07.gif";